import { __spreadArrays, __assign, __rest } from 'tslib';

var formatCallbackString = function (cbKey, arity) {
    var paramSlots = '';
    for (var i = 0; i < arity; i++) {
        paramSlots += (paramSlots && ',') + "{" + i + "}";
    }
    return "window._yaNativeCbs.call(" + cbKey + "," + paramSlots + ")";
};
/**
 * 네이티브 핸들러를 감싸서 액션 호출에 사용할 수 있는 형태로 만든다.
 *
 * 호출 시 네이티브 핸들러에 전달하고, `window._yaNativeCbs`에 콜백을 등록한다.
 * @param nativeHandler
 */
var createDispatch = function (nativeHandler) {
    if (!window._yaNativeCbs) {
        window._yaNativeCbs = {};
    }
    // 콜백 헬퍼
    if (!window._yaNativeCbs.call) {
        window._yaNativeCbs.call = function (key) {
            var _a, _b;
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            if (window._yaNativeCbs[key]) {
                (_b = (_a = window._yaNativeCbs)[key]) === null || _b === void 0 ? void 0 : _b.call.apply(_b, __spreadArrays([_a], args));
                delete window._yaNativeCbs[key];
            }
            else {
                console.warn("Tried to call " + key + " which is undefined. Did it timed out? Arguments:", args);
            }
        };
    }
    var cbKey = 0;
    return function (path, params, callback, cbArity, timeout) {
        cbKey += 1;
        if (window._yaNativeCbs[cbKey]) {
            console.warn("Callback key " + cbKey + " is already assigned. Did you create multiple instances of yaNative?");
        }
        var timeoutId = timeout &&
            setTimeout(function () {
                window._yaNativeCbs.call(cbKey, false);
            }, timeout);
        window._yaNativeCbs[cbKey] = function (success) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            timeoutId && clearTimeout(timeoutId);
            callback === null || callback === void 0 ? void 0 : callback.apply(void 0, __spreadArrays([success], args));
        };
        nativeHandler(__assign(__assign({ $path: path }, (params ? { $param: params } : {})), (callback ? { $cb: formatCallbackString(cbKey, cbArity) } : {})));
    };
};

/**
 * 웹뷰에서 주입하는 네이티브 핸들러를 반환한다.
 * @returns 네이티브 핸들러가 있으면 그 함수, 없으면 `undefined`.
 */
var getNativeHandler = function () {
    var _a, _b, _c, _d;
    if ((_a = window['android']) === null || _a === void 0 ? void 0 : _a['action']) {
        return [
            'android',
            function (params) {
                setTimeout(function () {
                    window['android'].action(JSON.stringify(params));
                }, 15);
            },
        ];
    }
    if ((_d = (_c = (_b = window['webkit']) === null || _b === void 0 ? void 0 : _b['messageHandlers']) === null || _c === void 0 ? void 0 : _c['observe']) === null || _d === void 0 ? void 0 : _d['postMessage']) {
        return [
            'ios',
            function (params) {
                setTimeout(function () {
                    window['webkit'].messageHandlers.observe.postMessage(params);
                }, 15);
            },
        ];
    }
};

function baseFactory() {
    var nativeHandler = getNativeHandler();
    if (!nativeHandler) {
        return { isEnabled: false };
    }
    var os = nativeHandler[0], handler = nativeHandler[1];
    var base;
    var dispatch = createDispatch(handler);
    try {
        base = {
            _dispatch: function (path, params, cb, cbArity, timeout) {
                if (this.isEnabled) {
                    dispatch(path, params, cb, cbArity, timeout);
                }
            },
            isEnabled: true,
            enabledFor: os,
            actions: function (param, cb, timeout) {
                if (timeout === void 0) { timeout = 5000; }
                this._dispatch('common/actions', param, cb, 1, timeout);
            },
            // common
            yaInfo: function (cb, timeout) {
                if (timeout === void 0) { timeout = 5000; }
                this._dispatch('common/yaInfo', null, cb, 2, timeout);
            },
            appVersion: function (cb, timeout) {
                if (timeout === void 0) { timeout = 5000; }
                this._dispatch('common/appVersion', null, cb, 2, timeout);
            },
            dismiss: function (cb, timeout) {
                if (timeout === void 0) { timeout = 5000; }
                this._dispatch('common/dismiss', null, cb, 1, timeout);
            },
            kinesis: function (param, cb, timeout) {
                if (timeout === void 0) { timeout = 5000; }
                this._dispatch('common/kinesis', param, cb, 1, timeout);
            },
            braze: function (param, cb, timeout) {
                if (timeout === void 0) { timeout = 5000; }
                this._dispatch('common/braze', param, cb, 1, timeout);
            },
            brazeLogPurchase: function (param, cb, timeout) {
                if (timeout === void 0) { timeout = 5000; }
                this._dispatch('common/brazeLogPurchase', param, cb, 1, timeout);
            },
            deepLink: function (param, cb, timeout) {
                if (timeout === void 0) { timeout = 5000; }
                this._dispatch('common/deepLink', param, cb, 1, timeout);
            },
            login: function (param, cb, timeout) {
                if (timeout === void 0) { timeout = 5000; }
                this._dispatch('common/login', param, cb, 1, timeout);
            },
            wv: function (_a, cb, timeout) {
                if (timeout === void 0) { timeout = 5000; }
                var _b = _a.method, method = _b === void 0 ? 'get' : _b, param = __rest(_a, ["method"]);
                this._dispatch('common/wv', __assign({ method: method }, param), cb, 1, timeout);
            },
            setSwipeBack: function (param, cb, timeout) {
                if (timeout === void 0) { timeout = 5000; }
                this._dispatch('common/setSwipeBack', param, cb, 1, timeout);
            },
            fileDownload: function (param, cb, timeout) {
                if (timeout === void 0) { timeout = 10000; }
                this._dispatch('common/fileDownload', param, cb, 1, timeout);
            },
            clearStack: function (param, cb, timeout) {
                if (timeout === void 0) { timeout = 5000; }
                this._dispatch('common/clearStack', param, cb, 1, timeout);
            },
            brightnessMax: function (param, cb, timeout) {
                if (timeout === void 0) { timeout = 5000; }
                this._dispatch('common/brightnessMax', param, cb, 1, timeout);
            },
            androidBackKeyFunc: function (param, cb, timeout) {
                if (timeout === void 0) { timeout = 5000; }
                this._dispatch('common/androidBackKeyFunc', param, cb, 1, timeout);
            },
            useBackFunc: function (param, cb, timeout) {
                if (timeout === void 0) { timeout = 5000; }
                this._dispatch('common/useBackFunc', param, cb, 1, timeout);
            },
            shareContent: function (param, cb, timeout) {
                if (timeout === void 0) { timeout = 5000; }
                /**
                 * iOS 8.67.0(17) 미만 대응 예외 처리
                 * - 8.67.0(17) 미만 버전은 'desc' 사용 중
                 * - 8.67.0(17) 이상 버전은 규격서에 정의된 'description' 필드 사용
                 */
                if (param.sendTo === 'kakao' && param.data.description) {
                    param.data.desc = param.data.description;
                }
                this._dispatch('common/shareContent', param, cb, 1, timeout);
            },
            agreementUpdate: function (cb, timeout) {
                if (timeout === void 0) { timeout = 5000; }
                this._dispatch('common/agreementUpdate', null, cb, 1, timeout);
            },
            requestSync: function (param, cb, timeout) {
                if (timeout === void 0) { timeout = 5000; }
                this._dispatch('common/requestSync', param, cb, 1, timeout);
            },
            ga4f: function (params, cb, timeout) {
                if (timeout === void 0) { timeout = 5000; }
                this._dispatch('common/ga4f', params, cb, 1, timeout);
            },
            // gplace
            failReservation: function (param, cb, timeout) {
                if (timeout === void 0) { timeout = 5000; }
                this._dispatch('gplace/failReservation', param, cb, 1, timeout);
            },
            // place
            billingDetail: function (param, cb, timeout) {
                if (timeout === void 0) { timeout = 5000; }
                this._dispatch('place/billingDetail', param, cb, 1, timeout);
            },
            reservationComplete: function (param, cb, timeout) {
                if (timeout === void 0) { timeout = 5000; }
                this._dispatch('place/reservationComplete', param, cb, 1, timeout);
            },
            // member
            withdrawComplete: function (param, cb, timeout) {
                if (timeout === void 0) { timeout = 5000; }
                this._dispatch('member/withdrawComplete', param, cb, 1, timeout);
            },
            pushStatus: function (cb, timeout) {
                if (timeout === void 0) { timeout = 5000; }
                this._dispatch('common/pushStatus', null, cb, 2, timeout);
            },
            requestPushAuthorization: function (cb, timeout) {
                if (timeout === void 0) { timeout = false; }
                this._dispatch('common/requestPushAuthorization', null, cb, 2, timeout);
            },
            locationStatus: function (cb, timeout) {
                if (timeout === void 0) { timeout = 5000; }
                this._dispatch('common/locationStatus', null, cb, 2, timeout);
            },
            requestLocationAuthorization: function (cb, timeout) {
                if (timeout === void 0) { timeout = false; }
                this._dispatch('common/requestLocationAuthorization', null, cb, 2, timeout);
            },
            // pip
            requestPipMode: function (cb, timeout) {
                if (timeout === void 0) { timeout = 5000; }
                this._dispatch('pip/requestPipMode', null, cb, 1, timeout);
            },
            broadcastState: function (param, cb, timeout) {
                if (timeout === void 0) { timeout = 5000; }
                this._dispatch('pip/broadcastState', param, cb, 1, timeout);
            },
            logout: function (cb, timeout) {
                if (timeout === void 0) { timeout = 5000; }
                this._dispatch('member/logout', null, cb, 1, timeout);
            },
            filter: function (param, cb, timeout) {
                if (timeout === void 0) { timeout = 5000; }
                this._dispatch('common/filter', param, cb, 2, timeout);
            },
            setFilter: function (param, cb, timeout) {
                if (timeout === void 0) { timeout = 5000; }
                this._dispatch('common/setFilter', param, cb, 1, timeout);
            },
            wishListUpdate: function (param, cb, timeout) {
                if (timeout === void 0) { timeout = 5000; }
                this._dispatch('common/wishListUpdate', param, cb, 1, timeout);
            },
            canOpen: function (param, cb, timeout) {
                if (timeout === void 0) { timeout = 5000; }
                this._dispatch('common/canOpen', param, cb, 2, timeout);
            },
            flag: function (param, cb, timeout) {
                if (timeout === void 0) { timeout = 5000; }
                this._dispatch('common/flag', param, cb, 2, timeout);
            },
            setFlag: function (param, cb, timeout) {
                if (timeout === void 0) { timeout = 5000; }
                this._dispatch('common/setFlag', param, cb, 1, timeout);
            },
            keyword: function (param, cb, timeout) {
                if (timeout === void 0) { timeout = 5000; }
                this._dispatch('search/keyword', param, cb, 1, timeout);
            },
            biometricStatus: function (cb, timeout) {
                if (timeout === void 0) { timeout = 5000; }
                this._dispatch('common/biometricStatus', null, cb, 2, timeout);
            },
            appleLoginResult: function (params, cb, timeout) {
                if (timeout === void 0) { timeout = 5000; }
                this._dispatch('member/appleLoginResult', params, cb, 1, timeout);
            },
            canGoBack: function (cb, timeout) {
                if (timeout === void 0) { timeout = 5000; }
                this._dispatch('common/canGoBack', null, cb, 2, timeout);
            },
            getNolAccessToken: function (cb, timeout) {
                if (timeout === void 0) { timeout = 5000; }
                this._dispatch('member/getNolAccessToken', null, cb, 2, timeout);
            },
            reloadWebPage: function (param, cb, timeout) {
                if (timeout === void 0) { timeout = 5000; }
                this._dispatch('common/reloadWebPage', param, cb, 1, timeout);
            },
            checkVital: function (cb, timeout) {
                if (timeout === void 0) { timeout = 5000; }
                this._dispatch('common/checkVital', null, cb, 1, timeout);
            },
            hasSigningKeyPair: function (cb, timeout) {
                if (timeout === void 0) { timeout = 5000; }
                this._dispatch('signature/hasSigningKeyPair', null, cb, 1, timeout);
            },
            signWithKeyPair: function (param, cb, timeout) {
                if (timeout === void 0) { timeout = 5000; }
                this._dispatch('signature/signWithKeyPair', param, cb, 2, timeout);
            },
            permitCamera: function (cb, timeout) {
                if (timeout === void 0) { timeout = 5000; }
                this._dispatch('common/permitCamera', null, cb, 1, timeout);
            },
        };
    }
    catch (e) {
        return {
            isEnabled: false
        };
    }
    return base;
}
var yaNative;
function getYaNative() {
    if (yaNative) {
        return yaNative;
    }
    yaNative = baseFactory();
    return yaNative;
}

export { getYaNative };
